﻿/**
 * ohbookmark Interactions
 * Lightweight interactions: full-screen menu, header scroll, product hover, reveal animations, marquee, product-card quick add.
 */
(function () {
  'use strict';

  function initMenu() {
    var toggle = document.querySelector('[data-oh-menu-toggle]');
    var drawer = document.querySelector('[data-oh-menu-drawer]');
    var closeBtns = document.querySelectorAll('[data-oh-menu-close]');
    var links = document.querySelectorAll('[data-oh-menu-drawer] a[href]');

    function open() {
      if (drawer) drawer.classList.add('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('oh-menu-open');
    }

    function close() {
      if (drawer) drawer.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('oh-menu-open');
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        var isOpen = drawer && drawer.classList.contains('is-open');
        if (isOpen) {
          close();
        } else {
          open();
        }
      });
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    links.forEach(function (link) {
      link.addEventListener('click', function () {
        setTimeout(close, 200);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var isOpen = drawer && drawer.classList.contains('is-open');
        if (isOpen) close();
      }
    });

    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) close();
      });
    }
  }

  function initHeaderScroll() {
    var header = document.querySelector('[data-oh-header]');
    if (!header) return;

    var ticking = false;

    function update() {
      var y = window.scrollY;
      if (y > 40) {
        header.classList.add('oh-header--scrolled');
      } else {
        header.classList.remove('oh-header--scrolled');
      }
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  function initRevealAnimations() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var targets = document.querySelectorAll('.oh-animate-fade-up, .oh-animate-scale-in, .oh-stagger-item');
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initMarquee() {
    var tracks = document.querySelectorAll('[data-oh-marquee]');
    tracks.forEach(function (track) {
      var content = track.innerHTML;
      track.innerHTML = content + content;
    });
  }

  function initDeferredProductHover() {
    if (window.__ohDeferredProductHoverBound) return;
    window.__ohDeferredProductHoverBound = true;

    var hoverQuery = window.matchMedia('(any-hover: hover) and (any-pointer: fine)');

    document.addEventListener(
      'pointerover',
      function (event) {
        if (event.pointerType === 'touch' || !hoverQuery.matches || !(event.target instanceof Element)) return;

        var card = event.target.closest('.oh-product-card[data-oh-deferred-hover]');
        if (!card || (event.relatedTarget instanceof Node && card.contains(event.relatedTarget))) return;

        var template = card.querySelector('template[data-oh-product-hover-template]');
        var sourceImage = template && template.content.querySelector('img');
        if (!template || !sourceImage) return;

        var image = sourceImage.cloneNode(true);
        image.addEventListener(
          'load',
          function () {
            card.classList.add('oh-product-card--has-hover');
          },
          { once: true }
        );
        image.addEventListener(
          'error',
          function () {
            image.remove();
          },
          { once: true }
        );

        template.replaceWith(image);
      },
      { passive: true }
    );
  }

  function initCardQuickAddFeedback() {
    function getPendingForms(variantId) {
      return Array.prototype.filter.call(
        document.querySelectorAll('.oh-product-card__quick-add-form[data-oh-quick-add-pending="true"]'),
        function (form) {
          var input = form.querySelector('[name="id"]');
          return input && String(input.value) === String(variantId);
        }
      );
    }

    function setState(form, state, message) {
      var button = form.querySelector('button[type="submit"]');
      var text = form.querySelector('[data-oh-quick-add-text]');
      var status = form.querySelector('[data-oh-quick-add-status]');
      var productForm = form.closest('product-form');
      var errorBox = productForm && productForm.querySelector('.product-form__error-message-wrapper');
      var errorText = errorBox && errorBox.querySelector('.product-form__error-message');
      if (!button || !text || !status) return;

      window.clearTimeout(form.ohQuickAddTimeout);

      if (state === 'adding') {
        if (errorBox) errorBox.hidden = true;
        form.dataset.ohQuickAddPending = 'true';
        button.setAttribute('aria-busy', 'true');
        text.textContent = text.dataset.addingText;
        status.textContent = text.dataset.addingText;
        form.ohQuickAddTimeout = window.setTimeout(function () {
          setState(form, 'error', button.dataset.errorText);
        }, 15000);
        return;
      }

      delete form.dataset.ohQuickAddPending;
      button.removeAttribute('aria-busy');

      if (state === 'added') {
        if (errorBox) errorBox.hidden = true;
        text.textContent = text.dataset.addedText;
        status.textContent = text.dataset.addedText;
        form.ohQuickAddTimeout = window.setTimeout(function () {
          setState(form, 'idle');
        }, 1200);
        return;
      }

      text.textContent = text.dataset.defaultText;
      status.textContent = message || '';
      if (errorBox) {
        errorBox.hidden = state !== 'error';
        if (state === 'error' && errorText) errorText.textContent = message || button.dataset.errorText;
      }
    }

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target.closest && event.target.closest('.oh-product-card__quick-add-form');
        if (!form) return;

        var button = form.querySelector('button[type="submit"]');
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        setState(form, 'adding');
      },
      true
    );

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      getPendingForms(event.productVariantId).forEach(function (form) {
        setState(form, 'added');
      });
    });

    subscribe(PUB_SUB_EVENTS.cartError, function (event) {
      if (!event || event.source !== 'product-form') return;
      var errorMessage = typeof event.errors === 'string' ? event.errors : event.message;
      getPendingForms(event.productVariantId).forEach(function (form) {
        setState(form, 'error', errorMessage);
      });
    });
  }

  function init() {
    initMenu();
    initHeaderScroll();
    initRevealAnimations();
    initMarquee();
    initDeferredProductHover();
    initCardQuickAddFeedback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
